import { connect } from 'react-redux';

import { ModalHeader } from 'UIPackage/ModalModule/components/ModalHeader';
import { Button } from 'UIPackage/MainModule/components/Button';
import { ModalBody } from 'UIPackage/ModalModule/components/ModalBody';
import { ModalActions } from 'UIPackage/ModalModule/components/ModalActions';
import { Modal } from 'UIPackage/ModalModule/components/Modal';

import styles from './Judgment.module.scss';
import { IKnmErknmFormSubject } from '../MainModule/interfaces/IKnmErknmFormSubject';
import { IKnmErknmFormAct } from '../MainModule/interfaces/IKnmErknmFormAct';
import { JudgmentModalElement } from './JudgmentModalElement';
import { IKnmErknmFormResultDecision } from '../MainModule/interfaces/IKnmErknmFormResultDecision';
import { IKnmErknmFormJudgment } from '../MainModule/interfaces/IKnmErknmFormJudgment';
import { IKnmFormRef } from '../../KnmPackage/MainModule/interfaces/IKnmFormRef';

interface ITemplateAddJudgmentModalProps {
  formRef: IKnmFormRef | undefined;
  visible: boolean;
  modalType: 'organization' | 'actsAndDecisions' | 'judgments';
  judgmentItemName?: string;
  judgmentItemSubjectDataItemName?: string;
  onSave: () => void;
  onCancel: () => void;
  organizations?: IKnmErknmFormSubject[] | undefined;
  acts?: IKnmErknmFormAct[] | undefined;
  decisions?: IKnmErknmFormResultDecision[] | undefined;
  judgements?: IKnmErknmFormJudgment[] | undefined;
}

const AddJudgmentModalWithoutStore = ({
  formRef,
  visible,
  modalType,
  judgmentItemName,
  judgmentItemSubjectDataItemName,
  onSave,
  onCancel,
  organizations,
  acts,
  decisions,
  judgements,
}: ITemplateAddJudgmentModalProps) => {
  const modalTitle = () => {
    if (modalType === 'organization') {
      return 'Выбор контролируемого лица';
    }
    if (modalType === 'actsAndDecisions') {
      return 'Выбор акта (решения) КНМ';
    }

    return 'Выбор судебного решения';
  };
  const modalSubTitle = () => {
    if (modalType === 'organization') {
      return 'Выберите контролируемое лицо, в отношении которого принято решение';
    }
    if (modalType === 'actsAndDecisions') {
      return 'Выберите акт (решение) в рамках контрольного (надзорного) мероприятия, которое было отменено или отменено частично';
    }

    return 'Выберите судебное решение в рамках контрольного (надзорного) мероприятия, которое было отменено или отменено частично';
  };

  return (
    <Modal modalBodyClassName={styles.ModalBody} visible={visible} onClose={onCancel}>
      <ModalHeader title={modalTitle()} sizeText="medium" color="black" />
      <ModalBody size="content" border="bottom" overflow="scroll">
        <h4 className={styles.Text}>{modalSubTitle()}</h4>
        {modalType === 'organization' && organizations && (
          <div>
            {organizations.map(organization => (
              <JudgmentModalElement
                formRef={formRef}
                key={organization.guid}
                modalType={modalType}
                judgmentItemName={judgmentItemName}
                organizationToSelect={organization}
              />
            ))}
          </div>
        )}
        {modalType === 'organization' && !organizations?.length && (
          <div className={styles.EmptyModalText}>
            Для заполнения данных о контролируемом лице, в отношении которого принято решение, необходимо создать запись
            о контролируемом лице и сохранить её в записи паспорта КНМ
          </div>
        )}
        {modalType === 'actsAndDecisions' && (acts || decisions) && (
          <div>
            {acts?.map(act => (
              <JudgmentModalElement
                formRef={formRef}
                key={act.guid}
                modalType={modalType}
                judgmentItemName={judgmentItemName}
                judgmentItemSubjectDataItemName={judgmentItemSubjectDataItemName}
                actToSelect={act}
              />
            ))}
            {decisions?.map(decision => (
              <JudgmentModalElement
                formRef={formRef}
                key={decision.guid}
                modalType={modalType}
                judgmentItemName={judgmentItemName}
                judgmentItemSubjectDataItemName={judgmentItemSubjectDataItemName}
                decisionToSelect={decision}
              />
            ))}
          </div>
        )}
        {modalType === 'actsAndDecisions' && !acts?.length && !decisions?.length && (
          <div className={styles.EmptyModalText}>
            Для отображения акта (решения) необходимо создать и сохранить их в записи паспорта КНМ по выбранному в
            судебном решении контролируемому лицу
          </div>
        )}
        {modalType === 'judgments' && judgements && (
          <div>
            {judgements.map(judgment => (
              <JudgmentModalElement
                formRef={formRef}
                key={judgment.guid}
                modalType={modalType}
                judgmentItemName={judgmentItemName}
                judgmentToSelect={judgment}
              />
            ))}
          </div>
        )}
        {modalType === 'judgments' && !judgements?.length && (
          <div className={styles.EmptyModalText}>
            Для отображения судебного решения необходимо создать запись судебного решения и сохранить её в записи
            паспорта КНМ
          </div>
        )}
      </ModalBody>
      <ModalActions>
        <Button
          text="Сохранить"
          id="saveButton"
          size="medium"
          disabled={!organizations && !acts && !judgements}
          onClick={onSave}
        />
        <Button text="Закрыть" size="medium" onClick={onCancel} />
      </ModalActions>
    </Modal>
  );
};

export const AddJudgmentModal = connect(null)(AddJudgmentModalWithoutStore);
